import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const OrganizerReservationsWrapper = styled.div`
  padding: 10px;

  .display-container {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 40px;

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      flex-direction: column;
      align-items: center;
      padding: 0 10px;
    }

    .reservations-container,
    .history-and-periods-container {
      margin: 10px;
      width: 100%;
    }

    .reservations-history-container {
      margin-top: 20px;
    }
  }

  .unavailable-periods-title,
  .reservations-history-title,
  .reservations-title {
    text-align: center;
    margin-bottom: 16px;
  }

  .reservations-content-container {
    height: 500px;
  }

  .unavailable-periods-content,
  .reservations-history-content {
    height: 210px;
  }

  .reservations-content-container,
  .reservations-history-content,
  .unavailable-periods-content {
    outline: 1px solid ${mainColors.main_color};
    border-radius: 20px;
    padding: 8px;
    overflow-y: scroll;

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      max-height: 500px;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .unavailable-periods-content {
    .period-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      background-color: ${mainColors.main_color_rgba(0.3)};
      border-radius: 8px;
      padding: 0 4px;
      margin: 4px 0;
    }

    .outdated-period {
      background-color: ${mainColors.addOpacityTo(mainColors.text_color_disabled, 0.3)};
    }

    .period-text {
      font-family: monospace;
      font-size: 14px;
      text-align: center;

      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        font-size: 12px;
      }
    }
    .cancel-btn {
      font-size: 12px;
    }
  }

  .button-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .set-unavailable-modal .modal-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 auto;
    padding: 40px;
    max-width: 280px;
    width: 100%;
    min-height: 160px;

    @media screen and (max-width: ${sizeStandards.screen.XS}px) {
      margin: 0 20px;
    }
  }

  .inputs-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > * {
      text-align: center;
    }

    .error-message {
      margin: 0;
      color: #ffb5b5;
    }
  }

  .hyphen {
    font-size: 40px;

    &::before {
      content: '–';
    }
  }

  .disable-modal-input {
    max-width: 110px;
  }

  .modal-submit-btn {
    padding: 6px 20px;
    margin: 0 auto;
  }

  @media screen and (max-width: ${sizeStandards.screen.XS - 80}px) {
    .modal-content {
      max-width: 230px;
      padding: 40px 20px;
    }
    .hyphen {
      font-size: 20px;
    }
  }

  .reservation-group {
    .reservation-date {
      font-weight: bold;
      text-align: center;
      margin: 12px 0;
    }

    .reservation-row {
      background: ${mainColors.main_color_rgba(0.6)};
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      @media screen and (max-width: ${sizeStandards.screen.SM}px) {
        flex-direction: column;
        align-items: center;
      }

      .reservation-time,
      .reservation-user {
        margin: 8px 40px;

        @media screen and (min-width: ${sizeStandards.screen
            .LG}px) and (max-width: ${sizeStandards.screen.XL}px) {
          margin: 8px 4px;
        }
      }

      .reservation-user {
        text-align: center;
      }

      .allow-rescheduling-btn {
        background: transparent;
        border: none;

        @media screen and (max-width: ${sizeStandards.screen.SM}px) {
          margin-top: 0;
        }

        &:hover {
          box-shadow: 0px 0px 6px 0px ${mainColors.text_color};
        }

        .allow-rescheduling-btn-text {
          max-width: 120px;
          margin: 0;

          @media screen and (max-width: ${sizeStandards.screen.SM}px) {
            max-width: unset;
          }
        }
      }

      .rescheduling-allowed-text {
        max-width: 120px;
        margin: 20px;

        @media screen and (max-width: ${sizeStandards.screen.SM}px) {
          max-width: unset;
        }
      }
    }
  }

  .reservation-history-group {
    .reservation-history-date {
      font-weight: bold;
      text-align: center;
      margin: 12px 0;
    }

    .reservation-history-row {
      background-color: ${mainColors.addOpacityTo(mainColors.text_color_disabled, 0.3)};
      display: grid;
      padding-right: 4px;
      /* grid-template-columns: 100px 80px 1fr; */
      align-items: center;
      grid-template-columns: 1fr auto 1fr;

      .reservation-time,
      .reservation-user {
        text-align: center;
      }

      .reservation-status {
        color: ${mainColors.text_color};
        border-radius: 8px;
        text-align: center;
        margin: 0 8px;
      }

      .status-cancelled {
        color: ${mainColors.error_color};
      }
    }
  }
`;

export default OrganizerReservationsWrapper;
